module.exports = __webpack_public_path__ + "static/media/geography.2cfd279c.svg";